import AsyncStorage from "@react-native-async-storage/async-storage";
import { clientConfigPath } from "../../config/Constant"
import { setOnDemand } from "../Reducers/appConfigReducer";


export const fetchOnDemand = () => {
    return async (dispatch, getState) => {
        try {
            const { currentGuestDetails } = getState().guestDetailsSlice;
            if(currentGuestDetails.reservationNumber){
                const sessionToken = await AsyncStorage.getItem("sessionToken");
    
                const response  = await clientConfigPath.post('/ondemand/externalLogin', {
                    header: {
                        sessionToken
                    },
                    payload: {
                        reservationNumber: currentGuestDetails.reservationNumber
                    }
                })
    
                dispatch(setOnDemand(response?.data?.payload))
            } 
        } catch (error) {
            const errorMessage = error.response?.data?.header?.status.msg || error?.message || "Something went wrong";
            dispatch(setOnDemand({error: errorMessage}))
        }
    }
}